import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { ECIFFilterConfig } from './filters/ECIFFilterConfig';
export const ECIFTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.ECIFPreApproval_Category],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: ECIFFilterConfig,
      AreaPath: [UATConstants.ECIFAreaPath],
      Title: UATConstants.TenantTitles.ECIF,
      ADOTitle: UATConstants.TenantADOText.ECIF,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateECIFRequest,
          Key: UATConstants.CreateActionMenuKey.CreateECIFRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'ecif',
        title: UATConstants.PlaceholdersAndTitles.ECIFTitle,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Assigned Team': 3,
          'ECIF_AdditionalContacts': 4,
          'ECIF_ApprovedBy': 5,
          'ECIF_ApprovedDate': 6,
          'ECIF_CommericalExecutive': 7,
          'ECIF_CompletionDate': 8,
          'ECIF_DealDetails': 9,
          'ECIF_EntityType': 10,
          'ECIF_EvaluateWork': 11,
          'ECIF_ExpectedOutcome': 12,
          'ECIF_IncrementalACR': 13,
          'ECIF_IncrementalRevenue': 14,
          'ECIF_Investment': 15,
          'ECIF_InvestmentApproved': 16,
          'ECIF_ProjectDetails': 17,
          'ECIF_Rejectedby': 18,
          'ECIF_RejectedDate': 19,
          'ECIF_ROI': 20,
          'ECIF_ROIAttached': 21,
          'ECIF_Spend': 22,
          'ECIF_SpendPlan': 23,
          'ECIF_StartDate': 24,
          'ECIF_SupplierName': 25,
          'ECIF_SupplierType': 26,
          'ECIF_TypeofActivity': 27,
          'ECIF_TypeofFunds': 28,
          'ECIFCustomerEnrollmentNumber': 29,
          'ECIFDeliveryMethod': 30,
          'ECIFIssuppliersameascustomer': 31,
          'ECIFProgramName': 32,
        },
      },
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedto', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'requestors', formFieldLabel: UATConstants.PlaceholdersAndTitles.Requestors, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'executiveCEName', formFieldLabel: UATConstants.PlaceholdersAndTitles.ECIFCommercialExecutive, apiFieldName: 'CommercialExecutive' },
        { formFieldName: 'ecifCECustomer', formFieldLabel: UATConstants.PlaceholdersAndTitles.ExecutiveCE, apiFieldName: 'CommercialExecutive' },
        { formFieldName: 'ecifAdditionalContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.AdditionalContact, apiFieldName: 'additionalcontacts' },
        { formFieldName: 'ecifAdditionalContact', formFieldLabel: UATConstants.PlaceholdersAndTitles.AdditionalContact, apiFieldName: 'CustomerEmailsToCC' },
        { formFieldName: 'ecifApprovedBy', formFieldLabel: UATConstants.PlaceholdersAndTitles.ApprovedBy, apiFieldName: 'approvedby' },
        { formFieldName: 'ecifRejectedBy', formFieldLabel: UATConstants.PlaceholdersAndTitles.RejectedBy, apiFieldName: 'rejectedby' },
        { formFieldName: 'ecifApprovedBy_RejectedBy', formFieldLabel: UATConstants.PlaceholdersAndTitles.ApprovedOrRejectedBy, apiFieldName: 'approvedbyorrejectedby' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '35a2abd7-9e87-4c83-9e53-7d4bb39f3a5f',
      systemViewsFolderId: '939588bb-0868-4424-8ebc-e8e4a72812e7',
      sharedViewsFolderId: 'fb0c0e5c-d9a0-4296-a189-13c1c691d8cd',
    },
  },
};
